import XhrRequestHandler from "../../lib/XhrRequestHandler";

export interface ICountry{
    pais_id: string,
    pais_nombre: string,
    pais_activo: string
}

export class MenuPermissionSystem {
  private readonly base = "/perfil-usuario-arbol-menu-cliente";

  constructor(private requestHandler: XhrRequestHandler) {}

  getDataMenuPermission() {
    return this.requestHandler.requestUrl(
      `${this.base}/datagridPerfilUsuarioArbolMenuCliente`,
    );
  }
}